import {Reports} from '/constant/TestIDs';

import {FilterOptionProps} from './AllOrdersReport.types';
import {GetGenerationItemsParams} from './AllOrdersReport.types';

export const generateAllOrders = ({tt}: any) => {
  const allOrders = [
    {
      title: tt('title', 'All Orders'),
      description: tt(
        'description.allOrders',
        'The All Orders report shows orders which meet the filter criteria. Order history is limited to 90 days.',
      ),
    },
    {
      title: tt('title.nfo', 'New Frontline orders'),
      description: tt(
        'description.nfo',
        '• Orders from new Frontline Clients & Coaches this month',
      ),
    },
    {
      title: tt('title.fo', 'Frontline orders'),
      description: tt(
        'description.fo',
        '• All orders from your Frontline Clients & Coaches.',
      ),
    },
    {
      title: tt('title.ng0o', 'New Generation 0 orders'),
      description: tt(
        'description.ng0o',
        '• Orders from new Clients or Coaches on your team this month.',
      ),
    },
    {
      title: tt('title.g0o', 'Generation 0 orders'),
      description: tt(
        'description.g0o',
        '• All orders from Clients or Coaches in your Generation Zero (may be from personal Clients or Clients from Coaches on your team).',
      ),
    },
    {
      title: tt('title.naoo', 'New all organization orders'),
      description: tt(
        'description.naoo',
        '• Orders from new Clients & Coaches in your organization this month.',
      ),
    },
    {
      title: tt('title.aoo', 'All organization orders'),
      description: tt(
        'description.aoo',
        '• All orders in your organization (all applicable generations).',
      ),
    },
  ];

  const [firstItem = {title: '', description: ''}, ...restItems] = allOrders;

  const body = [
    {description: firstItem.description}, // no empty title
    ...restItems,
  ];

  return {heading: firstItem.title, body};
};
1;

let generationItems: FilterOptionProps[] = [];
export const getGenerationItems = ({
  reportHeading = '',
  optionSelected = () => {},
}: GetGenerationItemsParams) => {
  reportHeading === 'Generation 0 Volume'
    ? /* The following condition is executed based on the value of 'reportheading' */
      (generationItems = [
        {
          text: 'Frontline',
          id: 'frontline',
          onPress: () => {
            optionSelected('frontline', 'generationItems');
          },
          selected: false,
          testID: Reports.reportFilterByGenerationFrontline,
          defaultVal: false,
          /* If the boolean value is not set to false and the frontline is not set to default, then the Generation filter will not be selected */
        },
        {
          text: 'Generation 0',
          id: 'genZero',
          onPress: () => {
            optionSelected('genZero', 'generationItems');
          },
          selected: true,
          testID: Reports.reportFilterByGenerationGenZero,
          defaultVal: false,
        },
        {
          text: 'All generations',
          id: 'allOrg',
          onPress: () => {
            optionSelected('allOrg', 'generationItems');
          },
          selected: false,
          testID: Reports.reportFilterByGenerationAll,
          defaultVal: false,
        },
      ])
    : reportHeading === 'Total Generation Volume'
    ? /* The following condition is executed based on the value of 'reportheading'*/
      (generationItems = [
        {
          text: 'Frontline',
          id: 'frontline',
          onPress: () => {
            optionSelected('frontline', 'generationItems');
          },
          selected: false,
          testID: Reports.reportFilterByGenerationFrontline,
          defaultVal: false,
        },
        {
          text: 'Generation 0',
          id: 'genZero',
          onPress: () => {
            optionSelected('genZero', 'generationItems');
          },
          selected: false,
          testID: Reports.reportFilterByGenerationGenZero,
          defaultVal: false,
        },
        {
          text: 'All generations',
          id: 'allOrg',
          onPress: () => {
            optionSelected('allOrg', 'generationItems');
          },
          selected: true,
          testID: Reports.reportFilterByGenerationAll,
          defaultVal: false,
        },
      ])
    : /* For default case, the below array is executed */
      (generationItems = [
        {
          text: 'Frontline',
          id: 'frontline',
          selected: true,
          onPress: () => {
            optionSelected('frontline', 'generationItems');
          },
          testID: Reports.reportFilterByGenerationFrontline,
          defaultVal: false,
        },
        {
          text: 'Generation 0',
          id: 'genZero',
          selected: false,
          onPress: () => {
            optionSelected('genZero', 'generationItems');
          },
          testID: Reports.reportFilterByGenerationGenZero,
          defaultVal: false,
        },
        {
          text: 'All generations',
          id: 'allOrg',
          selected: false,
          onPress: () => {
            optionSelected('allOrg', 'generationItems');
          },
          testID: Reports.reportFilterByGenerationAll,
          defaultVal: false,
        },
      ]);

  return generationItems;
};
